<div>

  <div class="mb-3x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.TITEL' | translate }}</h2>
    <div id="eric-error-massages" class="word-break"></div>
    <h5>{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.TEXT' | translate }}</h5>
  </div>

  <div class="form-row">
    <button (click)="addOrgangesellschaft()" *ngIf="!readonly && data?.organgesellschaften?.length < 2"
            class="btn btn-light ml-2 mb-2"
            id="addOrganschaft"
            title="{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ADD_ORGANSCHAFT' | translate }}">
      <em class="icon icon-svg icon-fi-hinzufuegen"></em>
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ADD_ORGANSCHAFT' | translate }}
    </button>
  </div>

  <div class="mb-5x">
    <ul class="list-group d-flex" id="organschaftenList">
      <ng-container *ngFor="let organgesellschaft of data.organgesellschaften; let i = index">
        <li
          (click)="toggleSelect(i)"
          (keypress)="toggleSelect(i)"
          [ngClass]="{'common-ui-background-color-selected': selectedIndex == i}" class="list-group-item common-ui-list-group-item"
          [tabIndex]="0"
          id="organschaften{{i}}">
          <div [ngClass]="{'active': selectedIndex === i }"
               class="text-truncate h5 list-group-item-heading ml-2x mb-0 list-item-title">
            {{organgesellschaft?.bezeichnung}}
          </div>
          <div class="common-ui-remove-element">
            <button
              (click)="removeOrgangesellschaft(i)"
              *ngIf="!readonly && data?.organgesellschaften?.length > 0"
              class="btn btn-light btn-img"
              id="removeOrganschaft{{i}}"
              title="{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.REMOVE_ORGANSCHAFT' | translate }}">
              <em class="icon icon-svg icon-fi-loeschen"></em>
            </button>
          </div>
        </li>
        <div [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
             class="containing-form">
          <common-ui-organgesellschaft-form
            [organgesellschaft]="organgesellschaft"
            [readonly]="readonly">
          </common-ui-organgesellschaft-form>

        </div>

      </ng-container>
    </ul>
  </div>

</div>
